"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
var is_node_1 = require("../is-node");
var react_apollo_1 = require("react-apollo");
var with_mparticle_listings_1 = require("./with_mparticle_listings");
var react_router_1 = require("react-router");
var mparticle_tracker_1 = require("../elog/mparticle_tracker");
var TRACKING_COMPLETE_PARAM = 'mp_complete';
var graphQLConfig = {
    props: function (props) { return props; },
    options: function (props) {
        return {
            variables: {
                id: props.routeParams.order_bundle_id,
            },
            ssr: false,
            context: {
                headers: {
                    // override user's currency, since all
                    // mParticle tracking needs to be normalized to USD
                    'X-Display-Currency': 'USD',
                },
            },
        };
    },
};
var ORDER_BUNDLES_QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query Commons_MParticle_OrderBundles(\n    $id: String\n  )\n  {\n    orderBundles(input: { ids: [$id] }) {\n      _id\n      paymentMethod\n      amountTotal {\n        amount\n      }\n      amountTax {\n        amount\n      }\n      amountShipping {\n        amount\n      }\n      orders {\n        nodes {\n          id\n          quantity\n          amountProduct {\n            amount\n          }\n          listing {\n            ...mParticleListingFields\n          }\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query Commons_MParticle_OrderBundles(\n    $id: String\n  )\n  {\n    orderBundles(input: { ids: [$id] }) {\n      _id\n      paymentMethod\n      amountTotal {\n        amount\n      }\n      amountTax {\n        amount\n      }\n      amountShipping {\n        amount\n      }\n      orders {\n        nodes {\n          id\n          quantity\n          amountProduct {\n            amount\n          }\n          listing {\n            ...mParticleListingFields\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), with_mparticle_listings_1.mParticleListingFields);
var TIMEOUT_LENGTH = 5000;
function trackMParticlePurchase(props, timeoutLength) {
    if (timeoutLength === void 0) { timeoutLength = TIMEOUT_LENGTH; }
    if (is_node_1.default)
        return null;
    if (props.location.query[TRACKING_COMPLETE_PARAM] === 'true')
        return;
    var orderBundles = props.data.orderBundles;
    if (orderBundles && orderBundles.length) {
        mparticle_tracker_1.trackEvent({
            orderBundle: orderBundles[0],
            eventName: mparticle_tracker_1.MParticleEventName.Purchase,
        });
        setTimeout(function () {
            var _a;
            react_router_1.browserHistory.replace({
                pathname: props.location.pathname,
                query: tslib_1.__assign(tslib_1.__assign({}, props.location.query), (_a = {}, _a[TRACKING_COMPLETE_PARAM] = true, _a)),
            });
        }, timeoutLength);
    }
    return null;
}
exports.trackMParticlePurchase = trackMParticlePurchase;
exports.default = react_apollo_1.graphql(ORDER_BUNDLES_QUERY, graphQLConfig)(trackMParticlePurchase);
var templateObject_1;
//# sourceMappingURL=track_purchase.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/track_purchase.js
// module id = 9OMQ
// module chunks = 20 21